var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.75C7.16751 20.75 3.25 16.8325 3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7121 8.21209C15.7032 8.22093 15.6949 8.23029 15.6872 8.24013L11.3467 13.7709L8.72985 11.154C8.36373 10.7879 7.77014 10.7879 7.40402 11.154C7.0379 11.5201 7.0379 12.1137 7.40402 12.4799L10.7121 15.7879C11.0782 16.154 11.6718 16.154 12.0379 15.7879C12.0461 15.7798 12.0538 15.7712 12.061 15.7622L17.0512 9.52434C17.404 9.15727 17.3995 8.57371 17.0379 8.21209C16.6718 7.84597 16.0782 7.84597 15.7121 8.21209Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.1f06e5a335d139bed66f4e8c187f7f02.svg";
export { ForwardRef as ReactComponent };